// extracted by mini-css-extract-plugin
export default {"medical-record-item":"MedicalRecordItem_medical-record-item__ubgmu","dropdown-menu-btn":"MedicalRecordItem_dropdown-menu-btn__CWjuS"};